import React from 'react';
import './App.css';
import AppContainer from './Router/AppContainer/AppContainer'

function App() {
  return (
    <div>
      <AppContainer />
    </div>
  );
}

export default App;
